@if (initialized && activeNavigationItem) {
    <div class="cn-commission-model-side mt-2">

        @if (activeNavigationItem.action === 'cn.CommissionModel') {
            @if (dto && dto.status != null) {
                <div class="flex align-items-center gap-2 mb-2">
                    <span class="font-medium">{{ dto.name }}</span>
                    <p-tag [value]="statusLabel(dto.status)" [severity]="statusSeverity(dto.status)"></p-tag>
                </div>
            }
            @if (modelWidget) {
                <mvs-widget [widgetData]="modelWidget"></mvs-widget>
            }
        }

        @if (activeNavigationItem.action === 'cn.CommissionRule') {
            @if (ruleWidget) {
                <mvs-widget
                        [widgetData]="ruleWidget"
                        (onObjectSelect)="handleRuleSelect($event)">
                </mvs-widget>
            }
        }

    </div>
}
